module.exports = __webpack_public_path__ + "img/reifenreparatur_kaltverfahren_784x514.4828db81.jpg";